import React from "react";
import { FastField } from "formik";

export default function Checkbox(props) {
  return (
    <FastField name={props.name}>
      {({ field, form }) => {
        return (
          <label>
            <input
              type="checkbox"
              checked={Boolean(field.value)}
              onChange={() => {
                form.setFieldValue(field.name, !Boolean(field.value));
              }}
            />
            {props.value}
          </label>
        )
      }}
    </FastField>
  );
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/Checkbox.jsx